import { Button } from '@/components/ui/button';
import {
  GiftCardTransactionsFragment,
  useGiftCardTransactionByPkQuery,
} from '@/gql/generated';
import { formatNumberToCurrency } from '@/lib/utils';
import { useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import EmailField from '../../../_components/email-field';
import MessageField from '../../../_components/message-field';
import PrinterReceipt from '../../../_components/printer-receipt';

export default function GiftCardReceiptPage() {
  const navigate = useNavigate();
  const { transaction_id: transactionId } = useParams();
  const [showEmail, setShowEmail] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');
  const value = searchParams.get('value');

  const transactionDetailByPk = useGiftCardTransactionByPkQuery(
    {
      id: transactionId ?? '',
    },
    { enabled: !!transactionId },
  );

  const data = transactionDetailByPk.data?.transaction_by_pk;

  return (
    <>
      <div className="flex flex-col items-center justify-center p-24">
        <div className="mx-auto size-full grow text-center">
          {type === 'redeem' ? (
            <>
              <div className="mb-2 text-3xl font-medium">
                Redemption success
              </div>
              <div className="mb-4 text-9xl font-bold">
                {formatNumberToCurrency(Number(value))}
              </div>
              <div className="mt-2 text-3xl">
                Current balance {formatNumberToCurrency(data?.balance_after)}
              </div>
            </>
          ) : (
            <>
              <div className="mt-6 text-5xl font-bold">
                Paid {formatNumberToCurrency(data?.price)}
              </div>
              <div className="mt-2 text-2xl text-gray-600">
                Balance {formatNumberToCurrency(data?.balance_after)}
              </div>
            </>
          )}

          <div className="mt-16">
            <div className="flex items-center justify-center gap-2">
              <div className="flex-1 border-t border-gray-300"></div>
              <span className="px-2 text-2xl">Need a receipt?</span>
              <div className="flex-1 border-t border-gray-300"></div>
            </div>
            <div className="mt-8 grid grid-cols-2 gap-4">
              <Button
                variant={'outline'}
                className="rounded-lg border border-gray-300 bg-white px-6 py-10 text-xl hover:bg-gray-50"
                onClick={() => navigate(`/gift-card`)}
              >
                No receipt
              </Button>

              <PrinterReceipt
                transaction={data as GiftCardTransactionsFragment}
                onPrintDone={() => navigate(`/gift-card`)}
                className="cursor-pointer rounded-lg border border-gray-300 bg-white p-6 text-center text-xl font-semibold hover:bg-gray-50"
              >
                Print
              </PrinterReceipt>

              <Button
                variant={'outline'}
                className="rounded-lg border border-gray-300 bg-white px-6 py-10 text-xl hover:bg-gray-50"
                onClick={() => setShowEmail(true)}
              >
                Email
              </Button>
              <Button
                variant={'outline'}
                className="rounded-lg border border-gray-300 bg-white px-6 py-10 text-xl hover:bg-gray-50"
                onClick={() => setShowMessage(true)}
              >
                Text message
              </Button>
            </div>
            <Button
              className="my-12 size-full h-24 w-full max-w-[448px] bg-primary text-3xl font-bold"
              onClick={() => navigate(`/gift-card`)}
            >
              Back to home
            </Button>
          </div>
        </div>
      </div>
      {showEmail && (
        <EmailField
          id={transactionId ?? ''}
          onClose={() => setShowEmail(false)}
        />
      )}
      {showMessage && (
        <MessageField
          id={transactionId ?? ''}
          onClose={() => setShowMessage(false)}
        />
      )}
    </>
  );
}
